function setrequestQuoteProducts(productform_content) {
    // Use native JS to query the needed elements inside the form container
    const formEl = (productform_content instanceof Element) ? productform_content : document.querySelector(productform_content);

    const getInputAttr = (selector, attr) => {
        const el = formEl.querySelector(selector);
        return el ? el.getAttribute(attr) : '';
    }
    const getInputVal = (selector) => {
        const el = formEl.querySelector(selector);
        return el ? el.value : '';
    }

    let product_id = getInputAttr('input.productcontent', 'data-productid'),
        product_title = getInputAttr('input.productcontent', 'data-producttitle'),
        product_handle = getInputAttr('input.productcontent', 'data-producthandle'),
        product_img = getInputAttr('input.productcontent', 'data-productimg'),
        product_price = getInputAttr('input.productcontent', 'data-productprice'),
        product_variantid = getInputVal('input[name="id"]'),
        product_variantlabel = getInputAttr('input.productcontent', 'data-productvariantlabel'),
        product_varianttitle = getInputAttr('input.productcontent', 'data-productvarianttitle'),
        product_qty = getInputVal('input[name="quantity"]'),
        product_minqty = getInputAttr('input[name="quantity"]', 'min'),
        product_stepqty = getInputAttr('input[name="quantity"]', 'step'),
        product_url = getInputAttr('input.productcontent', 'data-producturl');

    let option_list = '';
    const optionInputs = formEl.querySelectorAll('input.product-option-id');
    if(optionInputs.length > 0){
        optionInputs.forEach(function(input){
            const optional_productname = input.getAttribute('data-optionname');
            if(option_list !== ''){
                option_list = option_list + ', ' + optional_productname;
            }else{
                option_list = optional_productname;
            }
        });
    }

    const quoteproductData = {
        productId: product_id,
        productHandle: `${product_handle}`,
        productTitle: `${product_title}`,
        productImg: `${product_img}`,
        productPrice: `${product_price}`,
        productVariantId: `${product_variantid}`,
        productVariantLabel:`${product_variantlabel}`,
        productVarianttitle: `${product_varianttitle}`,
        productQty: `${product_qty}`,
        productminQty: `${product_minqty}`,
        productstepQty: `${product_stepqty}`,
        productUrl: `${product_url}`,
        productOptionname:`${option_list}`
    };

    const quoteproductList = [quoteproductData];
    let quotejsonResp, quotejsonRespArr, quotejsonRespArrStr;
    const quoternumberOfProducts = 10;
    const quoteCurrProductPagevariantId = quoteproductData.productVariantId;
    const quoteproductDataString = JSON.stringify(quoteproductList);
    const QuotelocalData = localStorage.getItem("quoteProduct");

    if (QuotelocalData === null) {
        localStorage.setItem("quoteProduct", quoteproductDataString);
    } else if (QuotelocalData) {
        const quoteoldProductData = localStorage.getItem("quoteProduct");
        const quotecountProductData = (quoteoldProductData.match(/productTitle/g) || []).length;
        const samequoteProductvariant = quoteoldProductData.includes(quoteCurrProductPagevariantId);
        if (quotecountProductData < quoternumberOfProducts && samequoteProductvariant == false) {
            quotejsonResp = JSON.parse(quoteoldProductData);
            quotejsonRespArr = quotejsonResp.concat(quoteproductList);
            quotejsonRespArrStr = JSON.stringify(quotejsonRespArr);
            localStorage.setItem("quoteProduct", quotejsonRespArrStr);
        }
    }

    addquoteproduct();
    let quoteproductsPopup = document.querySelector('.quotepopup-section');
    if(quoteproductsPopup.querySelector('.quotepopup-product-wrapper')){
        // close modal if present
        const closeBtn = document.querySelector('.quick-add-modal .quick-add-modal__toggle[aria-label="Close"]');
        if(closeBtn) closeBtn.click();
        quoteproductsPopup.classList.add('quoteopen');
        quoteproductsPopup.style.display = 'flex';
        document.body.classList.add('small-quotepopup-open');
    }
}

function setrequestQuoteOptionProducts(productform_content) {
    // Use native JS to query 
    const formEl = (productform_content instanceof Element) ? productform_content : document.querySelector(productform_content);
    const optionInputs = formEl.querySelectorAll('input.product-option-id');
    optionInputs.forEach(function(input){
      let product_id = input.getAttribute("data-optionid"),
        product_title = input.getAttribute("data-optionname"),
        product_handle = input.getAttribute("data-optionhandle"),
        product_img = input.getAttribute("data-optionimg"),
        product_price = input.getAttribute("data-optionprice"),
        product_variantid = input.value,
        product_variantlabel = input.getAttribute("data-productvariantlabel"),
        product_varianttitle = input.getAttribute("data-optionvarianttitle"),
        product_qty = formEl.querySelector('input[name="quantity"]')
          ? formEl.querySelector('input[name="quantity"]').value
          : "",
        product_minqty = formEl.querySelector('input[name="quantity"]')
          ? formEl.querySelector('input[name="quantity"]').getAttribute("min")
          : "",
        product_stepqty = formEl.querySelector('input[name="quantity"]')
          ? formEl.querySelector('input[name="quantity"]').getAttribute("step")
          : "",
        product_url = input.getAttribute("data-optionurl"),
        option_main_product = input.getAttribute("data-mainproductname");

      const quoteproductData = {
        productId: product_id,
        productHandle: `${product_handle}`,
        productTitle: `${product_title}`,
        productImg: `${product_img}`,
        productPrice: `${product_price}`,
        productVariantId: `${product_variantid}`,
        productVariantLabel: `${product_variantlabel}`,
        productVarianttitle: `${product_varianttitle}`,
        productQty: `${product_qty}`,
        productminQty: `${product_minqty}`,
        productstepQty: `${product_stepqty}`,
        productUrl: `${product_url}`,
        productOptionname: `Main_product: ${option_main_product}`,
      };
      const quoteproductList = [quoteproductData];
      let quotejsonResp, quotejsonRespArr, quotejsonRespArrStr;
      const quoternumberOfProducts = 10;
      const quoteCurrProductPagevariantId = quoteproductData.productVariantId;
      const quoteproductDataString = JSON.stringify(quoteproductList);
      const QuotelocalData = localStorage.getItem("quoteProduct");
      if (QuotelocalData === null) {
        localStorage.setItem("quoteProduct", quoteproductDataString);
      } else if (QuotelocalData) {
        const quoteoldProductData = localStorage.getItem("quoteProduct");
        const quotecountProductData = (quoteoldProductData.match(/productTitle/g) || []).length;
        const samequoteProductvariant = quoteoldProductData.includes(quoteCurrProductPagevariantId);
        if (quotecountProductData < quoternumberOfProducts && samequoteProductvariant == false) {
          quotejsonResp = JSON.parse(quoteoldProductData);
          quotejsonRespArr = quotejsonResp.concat(quoteproductList);
          quotejsonRespArrStr = JSON.stringify(quotejsonRespArr);
          localStorage.setItem("quoteProduct", quotejsonRespArrStr);
        }
      }

      addquoteproduct();
    });
}

function addquoteproduct(){
    let productsPopup_section = document.querySelector('.quotepopup-section');
    const quoteProducts = localStorage.getItem('quoteProduct');
    const productsArray = quoteProducts ? JSON.parse(quoteProducts) : [];
    let popupContent = '';
    productsArray.forEach(function(product) {
        let productVariantLabel_avail = product.productVariantLabel;
        if(productVariantLabel_avail || productVariantLabel_avail !== '' || productVariantLabel_avail !== undefined){
            productVariantLabel_avail = productVariantLabel_avail + ' : ';
        }else{
            productVariantLabel_avail = '';
        }
        let product_price = product.productPrice ? product.productPrice.replace("$", "") : '';
        let finaloptional_textval = ``;
        if(product.productOptionname !== undefined){
            if(product.productOptionname !== '' && !product.productOptionname.includes('Main_product')){
                const product_property = `Optional :`+product.productOptionname;
                const text = product_property.trim();
                const parts = text.split('Optional :');
                if (parts.length > 1 && parts !== '') {
                    let options = parts[1].split(',');
                    finaloptional_textval = '<span>Optional : </span><ul>';
                    for (var i = 0; i < options.length; i++) {
                        finaloptional_textval += '<li>' + options[i].trim() + '</li>';
                    }
                    finaloptional_textval += '</ul>';
                }
            }
        }
        popupContent += `
        <div class="quotepopup-product-item">
            <div class="quotepopup-product-img">
                <a href="${product.productUrl}" class="quotepopup-product-imglink">
                    <img src="${product.productImg}" alt="Quote popup product image"/>
                </a>
            </div>
            <div class="quotepopup-product-content">
                <div class="quotepopup-product-titlecontent">
                    <a href="${product.productUrl}" class="quotepopup-product-title small_body" data-producthandle="${product.productHandle}">${product.productTitle}</a>
                </div>
                ${product_price > 0 
                ? `<div class="quotepopup-product-price quoteprice-${product_price} small_body">${product.productPrice}</div>` 
                :``
                }
                <div class="quotepopup-product-variantcontent">
                    <div class="quotepopup-product-varianttxt">
                        ${ product.productVarianttitle != ''
                        ? `<span class="quotepopup-product-varianttitle">${productVariantLabel_avail}</span>
                        <span class="quotepopup-product-variantval">${product.productVarianttitle}</span>`
                        : ''
                        }
                        <input type="hidden" name="variantId[]" value="${product.productVariantId}"/>
                        <span class="quotepopup-product-price hide hidden visually-hidden">${product_price}</span>
                    </div>
                    <div class="quotepopup-product-propertywrap small_body">
                        <span class="quotepopup-product-propertytxt">${finaloptional_textval}</span>
                    </div>
                </div>
                <div class="quotepopup-product-qtyremove-content">
                    <div class="quotepopup-product-qtycontent">
                        <quantity-input class="quantity" data-url="${product.productUrl}" data-section="template--${product.productId}__main">
                            <button class="quantity__button no-js-hidden disabled" name="minus" type="button">
                                <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </button>
                            <input class="quantity__input" type="number" name="quantity" 
                            id="Quantity-template--${product.productId}__main" data-productqtyid="${product.productVariantId}" data-cart-quantity="" data-min="${product.productminQty}" min="${product.productminQty}" step="${product.productstepQty}" value="${product.productQty}" form="product-form-template--${product.productTitle}__main">
                            <button class="quantity__button no-js-hidden" name="plus" type="button">
                                <svg width="12" height="12" class="icon icon-plus" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 1V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M1 6L11 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </button>
                        </quantity-input>
                    </div>
                    <input type="hidden" name="quantity[]" value="${product.productQty}">
                    <input type="hidden" name="p_title[]" value="${product.productTitle}">
                    <input type="hidden" name="p_price[]" value="${product_price}">
                    <div class="quotepopup-product-removecontent">
                        <a href="javascript:void(0);" class="quotepopup-product-removelink" data-productid="${product.productId}" data-productremoveid="${product.productVariantId}">
                            <svg class="quotepopup-product-removelinksvg" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.375 3.49967L4.725 1.45801H9.275L9.625 3.49967" stroke="black" stroke-linejoin="round"/>
                                <path d="M1.75 3.5H12.25" stroke="black" stroke-linecap="round"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7916 3.5L10.2083 12.5417H3.79159L3.20825 3.5H10.7916Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5.54175 10.208H8.45841" stroke="black" stroke-linecap="round"/>
                            </svg>
                            <span class="quotepopup-product-removetxt">Remove</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        `;
    });
    if(popupContent !== ''){
        popupContent += `<div class="quotepopup-product-notewrap">
            <div class="quotepopup-note"><textarea name="customerNotes" class="form-control quotepopup-product-note" placeholder="Add Note"></textarea></div>
            <div class="quotepopup-product-shippingnote"><span>Note:</span> Shipping cost is not final until a final order is submitted</div>
        </div>
        `
        popupContent += `<div class="quotepopup-product-item quotepopup-product-moreitem">
            <a href="javascript:void(0);" class="quotepopup-moreproduct">
                <span class="quotepopup-moreproduct-icon">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.1999 7.69998H8.80002V1.29995C8.80002 0.858446 8.44158 0.5 7.99993 0.5C7.55842 0.5 7.19998 0.858446 7.19998 1.29995V7.69998H0.799949C0.358446 7.69998 0 8.05842 0 8.49993C0 8.94158 0.358446 9.30002 0.799949 9.30002H7.19998V15.6999C7.19998 16.1416 7.55842 16.5 7.99993 16.5C8.44158 16.5 8.80002 16.1416 8.80002 15.6999V9.30002H15.1999C15.6416 9.30002 16 8.94158 16 8.49993C16 8.05842 15.6416 7.69998 15.1999 7.69998Z" fill="#2A3492"/>
                </svg>                                   
                </span>
            </a>
            <div class="quotepopup-product-moreitem-txt small_body">(Add more items to quote)</div>
        </div>`;
    }
    const productWrapper = productsPopup_section.querySelector('.quotepopup-product-wrapper');
    if(productWrapper){
        productWrapper.innerHTML = popupContent;
    }

    const countEl = document.querySelector('.quotepopup-countproduct');
    if(countEl) countEl.innerHTML = productsArray.length;

    const headingWrap = document.querySelector('.quotepopup-headingwrap');
    const headingAvail = document.querySelector('.quotepopup-heading-available');
    const headingEmpty = document.querySelector('.quotepopup-heading-empty');
    const section = document.querySelector('.quotepopup-section');

    if(productsArray.length === 0){
        if(headingWrap) headingWrap.classList.add('quotepopup-centerheading');
        if(headingAvail) headingAvail.style.display = 'none';
        if(headingEmpty) headingEmpty.style.display = 'flex';
        if(section) section.classList.add('empty-quotesection');
    }else{
        if(headingWrap) headingWrap.classList.remove('quotepopup-centerheading');
        if(headingEmpty) headingEmpty.style.display = 'none';
        if(headingAvail) headingAvail.style.display = 'flex';
        if(section) section.classList.remove('empty-quotesection');
    }

    var quotedrawer_productlist = document.querySelector('.quoteproduct-list-wrapper');
    if(quotedrawer_productlist){
        var drawerWrap = quotedrawer_productlist.querySelector('.quotedrawer-product-wrapper');
        if(drawerWrap) drawerWrap.innerHTML = popupContent;
    }

    // Remove item from localstorage (native JS)
    document.querySelectorAll('.quotepopup-product-removecontent .quotepopup-product-removelink').forEach(function(el){
        el.addEventListener('click', function(){
            const product_variantid = el.getAttribute('data-productremoveid');
            removeProductById(product_variantid);
            addquoteproduct();
        });
    });

    // quantity update (native JS)
    document.querySelectorAll(".quotepopup-product-qtycontent .quantity__button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const quantityEl = btn.closest(".quantity").querySelector(".quantity__input");
        let product_qty_update = quantityEl.value;

        if (btn.name === "plus") {
          product_qty_update++;
        } else {
          product_qty_update--;
        }

        if (product_qty_update >= 1) {
          quantityEl.value = product_qty_update;
        }

        const product_qty_id = quantityEl.getAttribute("data-productqtyid");
        btn.closest(".quotepopup-product-qtyremove-content").querySelector('input[name="quantity[]"]').value =
          product_qty_update;
        updateProductQuantity(product_qty_id, product_qty_update);
      });
    });

    // Popup close btn (native JS)
    document.querySelectorAll(".quotepopup-section .quotepopup-closebtn").forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        event.stopPropagation();
        let quoteProducts_storage = localStorage.getItem("quoteProduct");
        let quoteProducts_length = quoteProducts_storage ? JSON.parse(quoteProducts_storage) : [];
        const popupSec = document.querySelector(".quotepopup-section");
        if (quoteProducts_length.length == 0) {
          popupSec.classList.remove("quoteopen");
          popupSec.style.display = "none";
          document.body.classList.remove("small-quotepopup-open");
        } else {
          popupSec.classList.toggle("quoteopen");
          popupSec.style.display = "flex";
          document.body.classList.toggle("small-quotepopup-open");
        }
      });
    });

    // quotepopup minimize close btn (native JS)
    document.addEventListener('click', function(e) {
        const target = e.target;
        const wrapper = target.closest('.quotepopup-section:not(.quoteopen) .quotepopup-wrapper');
        if(wrapper){
            e.preventDefault();
            if (!wrapper.closest('.quotepopup-section').classList.contains("quoteopen")) {
                let quoteProducts_storage = localStorage.getItem('quoteProduct');
                let quoteProducts_length = quoteProducts_storage ? JSON.parse(quoteProducts_storage) : [];
                const popupSec = document.querySelector('.quotepopup-section');
                if(quoteProducts_length.length == 0){
                    if(popupSec){
                        popupSec.classList.remove('quoteopen');
                        popupSec.style.display = 'none';
                        document.body.classList.remove('small-quotepopup-open');
                    }
                }else{
                    if(popupSec){
                        popupSec.classList.toggle('quoteopen');
                        popupSec.style.display = 'flex';
                        document.body.classList.toggle('small-quotepopup-open');
                    }
                }
            }
        }
    });
}

// Drawer outside click
let quotedrawer_outside = document.querySelector('quote-drawer');
if(quotedrawer_outside){
    quotedrawer_outside.addEventListener('click', function(e) {
        if (e.target === quotedrawer_outside) {
            let closeBtn = document.querySelector('.quotedrawer__close');
            if (closeBtn) closeBtn.click();
        }
    });
}

// Remove function
function removeProductById(productIdToRemove) {
    let storedProducts = localStorage.getItem('quoteProduct');
    let productArray = storedProducts ? JSON.parse(storedProducts) : [];
    let updatedProductArray = productArray.filter(function(product) {
        return product.productVariantId !== productIdToRemove;
    });
    localStorage.setItem('quoteProduct', JSON.stringify(updatedProductArray));
}

// Quantity function
function updateProductQuantity(productVariantId, newQuantity) {
    let storedProducts = localStorage.getItem('quoteProduct');
    let productArray = storedProducts ? JSON.parse(storedProducts) : [];
    let productIndex = productArray.findIndex(function(product) {
        return product.productVariantId === productVariantId;
    });
    if (productIndex !== -1) {
        productArray[productIndex].productQty = newQuantity;
        localStorage.setItem('quoteProduct', JSON.stringify(productArray));
    } else {
        console.error('Product with ID', productVariantId, 'not found.');
    }
}


// Request quote product
addquoteproduct();

// --- Event Bindings (no jQuery) ---
document.addEventListener('click', function(e) {
    // add quote from main product
    if(e.target.closest('.product-requestquote-btn')){
        e.preventDefault();
        let btn = e.target.closest('.product-requestquote-btn');
        let productform_content = btn.closest('product-form');
        console.log(productform_content);
        setrequestQuoteProducts(productform_content);
        if(productform_content && productform_content.querySelectorAll(".product-option-id").length > 0){
            setrequestQuoteOptionProducts(productform_content);
        }
    }

    // Check availability trigger quote
    if(e.target.classList.contains('mainproduct-checkavailability-txt')){
        const form = e.target.closest('.product-form');
        const requestBtn = form ? form.querySelector('.product-requestquote-btn') : null;
        if(requestBtn) requestBtn.click();
    }

    // Add quote from wishlist style page
    if(e.target.closest('.swym-product-quote-btn')){
        let btn = e.target.closest('.swym-product-quote-btn');
        let productform_content = btn.closest('.swym-product-actionbtnwrap');
        setrequestQuoteProducts(productform_content);
    }

    // Plus button for quote popup (add product flow)
    if(e.target.closest('.quotepopup-moreproduct')){
        e.preventDefault();
        let closeBtn = document.querySelector('.quotepopup-wrapper .quotepopup-closebtn');
        if (closeBtn) closeBtn.click();
        if (window.innerWidth >= 989) {
            let searchIcon = document.querySelector('.block__header-inlinemenu-search .header__icon--search');
            if (searchIcon) searchIcon.click();
        }else{
            let searchIconmob = document.querySelector('.block__header-menu-search .header__icon--search');
            if (searchIconmob) searchIconmob.click();
        }
    }
});

// Quote button in header to open quote drawer
document.querySelectorAll('.header-wrapper .quote_btn').forEach(function(btn){
    btn.addEventListener('click', function(){
        let storedProducts = localStorage.getItem('quoteProduct');
        let retstoredProducts = storedProducts ? JSON.parse(storedProducts) : [];
        if(storedProducts && storedProducts !== null && retstoredProducts.length > 0){
            if(document.body.classList.contains('block_menu-open')){
                let closeBtn = document.querySelector('.menu-drawer-closebtn');
                if(closeBtn) closeBtn.click();
            }
            let productsquoteDrawer = document.querySelector('.requestquote-drawer');
            if(productsquoteDrawer){
                productsquoteDrawer.classList.add('quotedrawer_active');
                document.body.classList.add('body_quotedrawer_active');
            }
        }else{
            window.location.href = '/account';
        }
    })
});

// quote popup "get quote" button to open quote drawer
document.querySelectorAll('.quotepopup-section .get_quotepopup_btn').forEach(function(btn){
    btn.addEventListener('click', function(event){
        event.stopPropagation();
        let productsPopup = document.querySelector('.quotepopup-section');
        if (productsPopup && productsPopup.querySelector('.quotepopup-product-wrapper')) {
            productsPopup.classList.remove('quoteopen');
            document.body.classList.remove('small-quotepopup-open');
        }
        let productsquoteDrawer = document.querySelector('.requestquote-drawer');
        if (productsquoteDrawer) {
            productsquoteDrawer.classList.add('quotedrawer_active');
            document.body.classList.add('body_quotedrawer_active');
        }
    });
});

// Request Quote drawer close functionality
document.querySelectorAll('.quotedrawer__close').forEach(function(btn){
    btn.addEventListener('click', function(){
        const rqDrawer = btn.closest('.requestquote-drawer');
        if(rqDrawer){
            rqDrawer.classList.remove('quotedrawer_active');
            document.body.classList.remove('body_quotedrawer_active');
        }
        let storedProducts = localStorage.getItem('quoteProduct');
        let retstoredProducts = storedProducts ? JSON.parse(storedProducts) : [];
        if((!storedProducts && storedProducts == null) || retstoredProducts.length == 0){
            setTimeout(function(){
                let qtf = document.getElementById('quoteproduct-listform');
                if(qtf){
                    qtf.classList.remove('quote-products-hide');
                    qtf.style.display = 'block';
                }
                let mh = document.querySelector('.quotedrawer-product-mainheading');
                if(mh) mh.style.display = 'block';
                let sc = document.querySelector('.quotedrawer-product-submittedcontent');
                if(sc){
                    sc.classList.remove('quote-submit-active');
                    sc.style.display = 'none';
                }
                localStorage.removeItem("quoteProduct");
            }, 1000);
        }
    });
});

// Guest account form link
document.querySelectorAll('.quote_guestaccount_formlink').forEach(function(btn){
    btn.addEventListener('click', function(e){
        e.preventDefault();
        let loginWrap = document.querySelector('.requestquote-login-formwrap');
        if(loginWrap) loginWrap.style.display = 'none';
        let reg = document.getElementById('quote-register');
        if(reg) reg.style.display = 'block';
    });
});

// Back to login from register
document.querySelectorAll('.quote_loginaccount_linktxt').forEach(function(btn){
    btn.addEventListener('click', function(e){
        e.preventDefault();
        let reg = document.getElementById('quote-register');
        if(reg) reg.style.display = 'none';
        let loginWrap = document.querySelector('.requestquote-login-formwrap');
        if(loginWrap) loginWrap.style.display = 'block';
    });
});

// Request Quote submit button
document.querySelectorAll('.quotedrawer-product-submitbtn').forEach(function(btn){
    btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        console.log('clickbtn');
        const txt = btn.querySelector('.quotedrawer-product-submitbtn-txt');
        const loader = btn.querySelector('.quotedrawer-product-submitbtn-loading');
        if(txt) txt.classList.add('hidden');
        if(loader) loader.classList.remove('hidden');
        var formElement = document.querySelector('#quoteproduct-listform');

        if (formElement) {
            if (!formElement.querySelector('[name="phone_number"]')) {
                var phoneInput = document.createElement('input');
                phoneInput.type = 'hidden';
                phoneInput.name = 'phone_number';
                phoneInput.value = '';
                formElement.appendChild(phoneInput);
            }
            if (!formElement.querySelector('[name="companyname"]')) {
                var companyInput = document.createElement('input');
                companyInput.type = 'hidden';
                companyInput.name = 'companyname';
                companyInput.value = '';
                formElement.appendChild(companyInput);
            }
        }
        var submittoAdd = new FormData(formElement);
        function moveAlong() {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', 'https://draftapi.usarollerchain.com/graphql/draftorder-create.php');
            xhr.onreadystatechange = function() {
                if (xhr.readyState == 4) {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        console.log("Product Added to Cart");
                        var line_item = {};
                        try { line_item = JSON.parse(xhr.responseText); } catch(e) {}
                        console.log(line_item);
                        // Hide/Show views
                        let qtf = document.getElementById('quoteproduct-listform');
                        if(qtf){
                            qtf.classList.add('quote-products-hide');
                            qtf.style.display = 'none';
                        }
                        let mh = document.querySelector('.quotedrawer-product-mainheading');
                        if(mh) mh.style.display = 'none';
                        let sc = document.querySelector('.quotedrawer-product-submittedcontent');
                        if(sc){
                            sc.classList.add('quote-submit-active');
                            sc.style.display = 'block';
                        }
                        const quoteProducts1 = localStorage.getItem('quoteProduct');
                        const productsArray1 = quoteProducts1 ? JSON.parse(quoteProducts1) : [];
                        let popupContent1 = '';
                        productsArray1.forEach(function(product) {
                            popupContent1 += `
                                <div class="main__quotepopup-product-item">
                                    <div class="main__quotepopup-product-img">
                                        <a href="${product.productUrl}" class="main__quotepopup-product-imglink">
                                            <img src="${product.productImg}" alt="Quote popup product image"/>
                                        </a>
                                    </div>
                                    <div class="main__quotepopup-product-content">
                                        <div class="main__quotepopup-product-titlecontent">
                                            <a href="${product.productUrl}" class="main__quotepopup-product-title small_body" data-producthandle="${product.productHandle}">${product.productTitle}</a>
                                        </div>
                                        <div class="main__productquote-qty"><span>Qty.:</span>${product.productQty}</div>
                                        </div>
                                    </div>
                                </div>
                        `;
                        });

                        let sublist = document.querySelector('.quotedrawer-productlist-submitted');
                        if(sublist)
                          sublist.innerHTML = popupContent1;

                        localStorage.removeItem("quoteProduct");
                        if(txt) txt.classList.remove('hidden');
                        if(loader) loader.classList.add('hidden');
                        const quoteProducts = localStorage.getItem('quoteProduct');
                        const productsArray = quoteProducts ? JSON.parse(quoteProducts) : [];
                        const headingWrap = document.querySelector('.quotepopup-headingwrap');
                        const headingAvail = document.querySelector('.quotepopup-heading-available');
                        const headingEmpty = document.querySelector('.quotepopup-heading-empty');
                        const section = document.querySelector('.quotepopup-section');
                        if(productsArray.length == 0){
                            if(headingWrap) headingWrap.classList.add('quotepopup-centerheading');
                            if(headingAvail) headingAvail.style.display = 'none';
                            if(headingEmpty) headingEmpty.style.display = 'flex';
                            if(section) section.classList.add('empty-quotesection');
                        }else{
                            if(headingWrap) headingWrap.classList.remove('quotepopup-centerheading');
                            if(headingEmpty) headingEmpty.style.display = 'none';
                            if(headingAvail) headingAvail.style.display = 'flex';
                            if(section) section.classList.remove('empty-quotesection');
                        }
                    } else {
                        console.log("fail");
                        console.log(xhr.responseText);
                    }
                }
            };
            xhr.send(submittoAdd);
        }
        moveAlong();
    });
});

// Account login submit functionality
let urlParams = new URLSearchParams(window.location.search);
if (urlParams.has("showDrawer") && urlParams.get("showDrawer") === "true") {
    // Open the drawer/modal
    let productsquoteDrawer = document.querySelector('.requestquote-drawer');
    if(productsquoteDrawer){
      productsquoteDrawer.classList.add('quotedrawer_active');
      document.body.classList.add('body_quotedrawer_active');
      let orignalurl = window.location.origin + window.location.pathname;
      history.pushState({}, '', `${orignalurl}`);
    }
}